export const CHOOSE_PERIOD = 'CHOOSE_PERIOD';
export const PAY_PRICE = 'PAY_PRICE';
export const DOWNLOAD = 'DOWNLOAD';
